// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// 🔧 프로젝트 설정
const firebaseConfig = {
  apiKey: "AIzaSyD5M5IxzxEIdnNzky3ZijElrEP8clYX31Y",
  authDomain: "jeonjolhyup.firebaseapp.com",
  projectId: "jeonjolhyup",
  // ✅ GCS 표준 도메인 (appspot.com) — 속도/안정성 이점
  storageBucket: "jeonjolhyup.appspot.com",
  appId: "1:547424969197:web:92044afa9f174d6eda87e4",
};

const app = initializeApp(firebaseConfig);

// =====================
// App Check (선택적)
// =====================
try {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    console.warn("App Check debug token enabled (localhost). Register it in Firebase Console.");
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Lf7Id8rAAAAAKIuk7JsCvCUqCZ4ZzxFciXy4uDY'),
    isTokenAutoRefreshEnabled: true
  });
} catch (e) {
  console.error("App Check initialization failed:", e);
}

// =====================
// Exports
// =====================
export const auth = getAuth(app);

export const functions = getFunctions(app, "asia-northeast3");
